// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"internetReception_wrapper__3HT6I","button":"internetReception_button__3Qbp8"};